<template>
<div id="app">
    <router-view />
</div>
</template>

<script>
import {
    clearLocalStorage
} from '@/utils/auth.js'
import {
    settingConfig
} from "@/api/dict"
export default {
    data() {
        return {
            openFlag: 0, //是否开放
        }
    },
    mounted() {
        if (process.env.NODE_ENV != 'development') {
            document.removeEventListener("contextmenu", cancelContextmenu)
            document.addEventListener("contextmenu", cancelContextmenu)

            function cancelContextmenu(e) {
                e.preventDefault()
            }
        }
        this.settingConfig()
    },
    methods: {
        /* 参数设置-获取特定key对应的value */
        async settingConfig() {
            // 用户电脑端学习是否开放
            let res = await settingConfig('zsm.pc.study.open.flag');
            if (res.data == 0) {
                clearLocalStorage();
                this.$router.replace('/');
                this.$message.error('电脑端暂不支持观看!')
            }
        }
    }

}
</script>

<style lang="scss">
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
}

#nav {
    padding: 30px;

    a {
        font-weight: bold;
        color: #2c3e50;

        &.router-link-exact-active {
            color: #42b983;
        }
    }
}
</style>
